import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router';
import ROUTE_PATHS from '../../routes/paths';

const ProposalPresentationPage: React.FC = () => {
  const navigate = useNavigate();
  const { appointmentId, appointmentProposalId } = useParams<{
    appointmentId: string;
    appointmentProposalId: string;
  }>();

  useEffect(() => {
    if (appointmentId && appointmentProposalId) {
      navigate(
        ROUTE_PATHS.APPOINTMENT_PATH({
          appointmentId,
          appointmentProposalId,
          path: 'present',
        }),
        { replace: true }
      );
    }
  }, [appointmentId, appointmentProposalId, navigate]);

  return <Outlet />;
};

export default ProposalPresentationPage;
